import React from 'react';

import autoBind from 'react-autobind';

// import other components within the same project here

import Localization from "../Localization.jsx"

import RootPage from "../pages/RootPage.jsx"
import LocaleListView from "../views/locale/LocaleListView.jsx"
import LocaleViewerBar from "../views/locale/LocaleViewerBar.jsx"
import CreateLocaleDialog from "../views/locale/CreateLocaleDialog.jsx"
import EditLocaleDialog from "../views/locale/EditLocaleDialog.jsx"
import LocaleOverviewDialog from "../views/locale/LocaleOverviewDialog.jsx"

const MAX_ROW_PER_PAGE    = 12;

class LocaleViewerPage extends React.Component {
  getSteps() {
    return [Localization.strings.DETAILS, Localization.strings.COVER_IMAGE, Localization.strings.PUBLISH];
  }

  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      data: [],
      targetLocaleEditData: {},
      filter: {
        school_id: props.root.getMySchoolId(),
        user_id: props.root.getMyUserId(),
      },
      count: MAX_ROW_PER_PAGE,

      isViewPublic: false,
      qaState: -1,

      currentPage: 0,
      totalPage: 0,
      localeID: -1,

      filterSchoolID: props.root.getMySchoolId(),
      filterUserID: props.root.getMyUserId(),
      filterKLA: 0,
      filterKeyword: "",
      active: true,
    };
    autoBind(this);

    this.refreshLocaleList();
  }

  overviewLocale(locale_id) {
    let localeData = this.getLocaleDataById(locale_id);
    this.props.root.setState({ targetLocaleData: localeData });
    this.props.root.state.targetLocaleData = localeData;

    this.refs.overviewLocaleDialog.setState({ open: true });
    this.refs.overviewLocaleDialog.state.open = true;
    this.refs.overviewLocaleDialog.refresh();
  }

  editLocaleByLocaleId(locale_id) {
    let localeData = this.getLocaleDataById(locale_id);
    this.editLocale(localeData);
  }

  editLocale(localeData, changeHistory=true) {
    this.props.root.setState({ targetLocaleData: localeData });
    this.props.root.state.targetLocaleData = localeData;
    this.props.root.changeStatus(this.props.root.STATUS_VIEW_LOCALE_STAGE());

    if (changeHistory) {
      this.props.root.pushHistory("locale/stage", {locale: localeData});
    }
  }

  showLocaleInfo(locale_id) {
    let localeData = this.getLocaleDataById(locale_id);
    this.setState({ targetLocaleEditData: localeData });
    this.state.targetLocaleEditData = localeData;

    this.refs.editLocaleDialog.setState({ open: true });
    this.refs.editLocaleDialog.state.open = true;
    this.refs.editLocaleDialog.changeTab(this.refs.editLocaleDialog.state.activeTab);
  }

  retrieveAnswerByLocaleId(locale_id) {
    let localeData = this.getLocaleDataById(locale_id);
    this.retrieveAnswer(localeData);
  }

  retrieveHeatmapByLocaleId(locale_id) {
    let localeData = this.getLocaleDataById(locale_id);
    this.retrieveHeatmap(localeData);
  }

  retrieveAnswer(localeData, changeHistory=true) {
    this.props.root.setState({ targetLocaleData: localeData });
    this.props.root.state.targetLocaleData = localeData;
    this.props.root.changeStatus(this.props.root.STATUS_VIEW_RETRIEVER());

    if (changeHistory) {
      this.props.root.pushHistory("locale/retriever", {locale: localeData});
    }
  }

  retrieveHeatmap(localeData, changeHistory=true) {
    this.props.root.setState({ targetLocaleData: localeData });
    this.props.root.state.targetLocaleData = localeData;
    this.props.root.changeStatus(this.props.root.STATUS_VIEW_HEATMAP());

    if (changeHistory) {
      this.props.root.pushHistory("locale/heatmap", {locale: localeData});
    }
  }

  deleteLocale(id) {
    this.setState({ localeID: id});
    this.state.localeID = id;
    let dialogText = {
      title: Localization.strings.DELETE_VITALS,
      content: Localization.strings.DELETE_REMINDER,
      confirm: Localization.strings.DELETE,
    };
    this.props.root.refs.confirmDialog.show(dialogText, this.deleteLocaleConfirmClicked, this.deleteLocaleCancelClicked);
  }

  deleteLocaleConfirmClicked() {
    if (this.state.localeID >= 0) {
      this.props.root.refs.API.request("delete_locale", { locale_id: this.state.localeID }, this.deleteLocaleOK, this.deleteLocaleFailed);
    }
    this.setState({ localeID: -1 });
    this.state.localeID = -1;
  }

  deleteLocaleCancelClicked() {
    this.setState({ localeID: -1 });
    this.state.localeID = -1;
  }

  deleteLocaleOK(res) {
    this.refreshLocaleList();
    this.props.root.addNotification(Localization.strings.DELETED);
  }

  deleteLocaleFail(err) {
    console.log("delete locale fail");
    this.props.root.addNotification(Localization.strings.DELETE_FAILED);
  }

  refreshLocaleList() {
    this.filterLocaleList(this.state.filterSchoolID, this.state.filterUserID, this.state.filterKLA, this.state.filterKeyword);
  }

  filterLocaleList(schoolID, userID, kla, keyword) {
    var requestObj = {
      filter: {},
      offset: this.state.currentPage * MAX_ROW_PER_PAGE,
      count: this.state.count,
      order_by: (this.refs.localeViewerBar? this.refs.localeViewerBar.state.localeSortField : "id"),
      order_mode: (this.refs.localeViewerBar? this.refs.localeViewerBar.state.localeSortOrder : "DESC"),
    };

    if (schoolID) {
      requestObj.filter['school_id'] = schoolID;
    }
    if (userID) {
      requestObj.filter['user_id'] = userID;
    }
    if (kla) {
      requestObj.filter['kla'] = kla;
    }
    if (keyword) {
      requestObj.filter['keyword'] = keyword;
    }
    if (this.state.qaState >= 0) {
      requestObj.filter['qa_state'] = this.state.qaState;
    }

    this.props.root.refs.API.request("get_locale_list", requestObj, this.getLocaleListOK, this.getLocaleListFailed);
  }

  filterLocaleByLocaleName(localeName) {
    this.setState({
      filterKeyword: localeName,
    });
    this.state.filterKeyword = localeName;
    this.changePage(0, false);
    this.filterLocaleList(this.state.filterSchoolID, this.state.filterUserID, this.state.filterKLA, this.state.filterKeyword);
  }

  filterLocaleBySchoolId(schoolId) {
    this.setState({
      filterSchoolID: schoolId,
    });
    this.state.filterSchoolID = schoolId;
    this.changePage(0, false);
    this.filterLocaleList(this.state.filterSchoolID);
  }

  filterLocaleBySchoolAndUserId(schoolId, userId){
    this.setState({
      filterSchoolID: schoolId,
      filterUserID: userId,
    });
    this.state.filterSchoolID = schoolId;
    this.state.filterUserID = userId;

    this.filterLocaleList(this.state.filterSchoolID, this.state.filterUserID);
  }

  filterLocaleByKLA(kla) {
    this.setState({
      filterKLA: kla,
    });
    this.state.filterKLA = kla;
    this.changePage(0, false);
    this.refreshLocaleList();
  }

  getLocaleListOK(res) {
    let count = res.body['count'];
    let page = Math.ceil(count / MAX_ROW_PER_PAGE);
    
    this.setState({
      data : res.body['result'],
      totalPage: page,
    });
    this.state.data = res.body['result'];
    this.state.totalPage = page;
  }

  getLocaleListFailed(err){
    console.log("get locale list failed");
  }

  getLocaleDataById(locale_id){
    let target_index = -1;
    for (var i = 0; i < this.state.data.length; i++) {
      if(this.state.data[i]['id'] == locale_id){
        return this.state.data[i];
      }
    }
    return null;
  }

  updateLocalLocaleDataById(locale_id, localeData){
    let temp = this.state.data;
    for (var i = 0; i < temp.length; i++) {
      if(temp[i]['id'] == locale_id){
        temp[i] = localeData;
      }
    }
    this.setState({ data: temp });
  }

  onQAStateChanged(e) {
    this.setState({ qaState: e.target.value });
    this.state.qaState = e.target.value;
    this.changePage(0, false);
    this.refreshLocaleList();
  }

  onViewAngleClicked() {
    let viewAngle = !this.state.isViewPublic;
    this.setState({ isViewPublic: viewAngle });
    this.state.isViewPublic = viewAngle;

    this.ChangeViewAnlge();
  }

  onViewAngleChanged(e) {
    let isPublic = false;
    switch (e.target.value) {
      case 0:
        isPublic = false;
        break;
      case 1:
        isPublic = true;
        break;
      default:
        break;
    }

    this.setState({ isViewPublic: isPublic });
    this.state.isViewPublic = isPublic;

    this.ChangeViewAnlge();
  }

  ChangeViewAnlge() {
    this.changePage(0, false);
    this.setState({
      filterSchoolID: (this.state.isViewPublic? null : this.props.root.getMySchoolId()),
      filterUserID: (this.state.isViewPublic? null : this.props.root.getMyUserId()),
    });
    this.state.filterSchoolID = (this.state.isViewPublic? null : this.props.root.getMySchoolId());
    this.state.filterUserID = (this.state.isViewPublic? null : this.props.root.getMyUserId());

    this.refs.localeViewerBar.clearFilter();
    if (!this.state.isViewPublic) {
      this.refs.localeViewerBar.setDefaultUserOption(this.state.filterUserID);
    }

    this.refreshLocaleList();
  }

  previousPage() {
    let page = this.state.currentPage;
    page--;
    if (page < 0) {
      page = 0;
    }
    this.changePage(page);
  }

  nextPage() {
    let page = this.state.currentPage;
    page++;
    if (page > this.state.totalPage - 1) {
      page = this.state.totalPage - 1;
    }
    this.changePage(page);
  }

  changePage(page, refresh=true) {
    this.setState({ currentPage: page });
    this.state.currentPage = page;
    if (refresh) {
      this.refreshLocaleList();
    }
  }

  onClearFilter() {
    this.changePage(0, false);
    this.setState({
      filterKLA: null,
      filterKeyword: null,
    });
    this.state.filterKLA = null;
    this.state.filterKeyword = null;
  }

  render() {
    return (
      <div style={{display:(this.state.active ? "": "none")}}>
        <LocaleViewerBar root={this.props.root} parent={this} ref="localeViewerBar"/>
        <CreateLocaleDialog root={this.props.root} parent={this} ref="createLocaleDialog"/>
        <EditLocaleDialog root={this.props.root} parent={this} ref="editLocaleDialog" localeData={this.state.targetLocaleEditData}/>
        <LocaleOverviewDialog root={this.props.root} parent={this} ref="overviewLocaleDialog"/>

        <LocaleListView root={this.props.root} parent={this} ref="localeListView"/>
      </div>
    )
  }
}

export default LocaleViewerPage;
